import { render } from "./AposWidgetModalTabs.vue?vue&type=template&id=bb384628&scoped=true"
import script from "./AposWidgetModalTabs.vue?vue&type=script&lang=js"
export * from "./AposWidgetModalTabs.vue?vue&type=script&lang=js"

import "./AposWidgetModalTabs.vue?vue&type=style&index=0&id=bb384628&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb384628"],['__file',"modal/ui/apos/components/AposWidgetModalTabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bb384628"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bb384628', __exports__)) {
    api.reload('bb384628', __exports__)
  }
  
  module.hot.accept("./AposWidgetModalTabs.vue?vue&type=template&id=bb384628&scoped=true", () => {
    api.rerender('bb384628', render)
  })

}


export default __exports__